
// skin care intro section
import React, { useState } from 'react';
import checkSkinIcon from '../../Assets/Images/rewamp/skin/hover state icon -check my skin.svg';
import cosmeticFlowIcon from '../../Assets/Images/rewamp/skin/hover state icon -cosmetic flow.svg';

const BUTTON_TIPS = {
  primary: {
    icon: checkSkinIcon,
    titleClass: 'title-primary',
    title: 'Skin Health Check',
    desc: 'For disease related concerns, atypical spots, or medical screening.',
  },
  button2: {
    icon: cosmeticFlowIcon,
    titleClass: 'title-button2',
    title: 'Cosmetic Skincare Analysis',
    desc: 'For glow & beauty related goals, skin texture and tone optimization.',
  },
};

const TipContent = ({ tip }) => (
  <>
    <img src={tip.icon} alt="" className="intro-btn-tooltip-icon-img" />
    <div>
      <div className={`intro-btn-tooltip-title ${tip.titleClass}`}>{tip.title}</div>
      <div className="intro-btn-tooltip-desc">{tip.desc}</div>
    </div>
  </>
);

const IntroSection = ({ items = [], report_count }) => {
  const [badgeHovered, setBadgeHovered] = useState(false);
  const [hoveredBtn, setHoveredBtn] = useState(null);

  if (!items.length) return null;

  const {
    heading,
    subheading,
    description,
    button,
    button1,
    button2,
    onButtonClick,
    onSecondButtonClick,
    onThirdButtonClick,
    image
  } = items[0];

  return (
    <div className="mx-auto w-full">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;600&display=swap');

        .intro-heading {
          font-family: 'Inter', sans-serif;
          font-weight: 700;
          font-size: 48px;
          line-height: 1.2;
          color: var(--color-brand-primary);
          margin-bottom: 6px;
        }

        .intro-subheading {
          font-size: 28px;
          line-height: 1.3;
          font-weight: 700;
          color: var(--color-brand-green);
          margin: 0 0 16px 0;
        }

        .intro-desc {
          font-size: 16px;
          line-height: 1.6;
          font-weight: 500;
          color: var(--color-text-subheading);
          margin-bottom: 32px;
          max-width: 600px;
        }

        .btn-primary {
          font-weight: 600;
          font-size: 16px;
          color: #ffffff;
          background: var(--color-brand-primary);
          border: 1.5px solid var(--color-brand-primary);
          border-radius: 999px;
          padding: 12px 28px;
          cursor: pointer;
          transition: background 0.2s;
        }
        .btn-primary:hover { background: var(--color-brand-primary-hover); }

        .btn-outline-wrapper {
          display: inline-block;
          border-radius: 999px;
        }

        .btn-outline {
          font-weight: 600;
          font-size: 16px;
          color: var(--color-brand-primary);
          background: #ffffff;
          border: 1.5px solid var(--color-brand-primary);
          border-radius: 999px;
          padding: 12px 28px;
          cursor: pointer;
          transition: background 0.2s;
        }
        .btn-outline:hover { background: #EAF3FA; }

        .btn-cosmetic {
          font-weight: 600;
          font-size: 16px;
          color: var(--color-brand-primary);
          background: linear-gradient(282.08deg, #DFF1FB 2.51%, #FFFFFF 100.3%);
          border: 1.5px solid var(--color-brand-primary);
          border-radius: 999px;
          padding: 12px 28px;
          cursor: pointer;
          animation: ctaGlowPulse 1.8s ease-in-out infinite;
        }

        @keyframes ctaGlowPulse {
          0%, 100% {
            box-shadow: 0px 4px 10px 0px #80DAF180;
          }
          50% {
            box-shadow: 0px 4px 18px 2px #80DAF1;
          }
        }

        .new-badge {
          position: absolute;
          top: -10px;
          right: 20px;
          background: linear-gradient(282.08deg, #BFEAF7 2.51%, #E6F7FC 100.3%);
          border: 1px solid #00B5E2;
          color: var(--color-brand-primary);
          font-size: 10px;
          font-weight: 700;
          letter-spacing: 0.3px;
          padding: 2px 8px;
          border-radius: 6px;
          animation: newBadgePulse 1.6s ease-in-out infinite;
          pointer-events: none;
          z-index: 5;
        }

        @keyframes newBadgePulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.12); }
        }

        /* BADGE */
        .reports-badge {
          min-width: clamp(120px, 14vw, 170px);
          background: #ffffff;
          border: 1px solid #80DAF1;
          border-radius: 8px;
          padding: 10px 16px;
          color: var(--color-brand-primary);

          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: center;
          text-align: left;

          /* 🔥 always glowing + floating */
          animation: glowPulse 3.5s ease-in-out infinite,
                     floatBadge 3.5s ease-in-out infinite;
        }

        .reports-badge:hover {
          transform: scale(1.08);
        }

        .badge-count {
          font-weight: 700;
          font-size: clamp(18px, 2.5vw, 28px);
          line-height: 1.1;
          color: var(--color-brand-green);
        }

        .badge-label {
          font-weight: 500;
          font-size: clamp(11px, 1.2vw, 16px);
          line-height: 1.25;
          margin-top: 2px;
        }

        /* ANIMATIONS */
        @keyframes glowPulse {
          0%, 100% {
            box-shadow: 0px 4px 10px 0px #80DAF180;
          }
          50% {
            box-shadow: 0px 4px 18px 2px #80DAF1;
          }
        }

        @keyframes floatBadge {
          0%, 100% {
            transform: translateY(0px) scale(1);
          }
          50% {
            transform: translateY(-6px) scale(1.03);
          }
        }

        /* LAYOUT */
        .intro-wrapper {
          background-color: #ffffff;
          background-image: var(--section-bg-gradient);
          display: flex;
          justify-content: space-between;
          padding: 20px max(64px, calc(50% - 656px));
          overflow: visible;
        }

        .intro-left {
          max-width: 50%;
          display: flex;
          flex-direction: column;
          margin-top: 48px;
        }

        .intro-right {
          width: 48%;
          display: flex;
          justify-content: flex-end;
        }

        .intro-btns {
          display: flex;
          gap: 14px;
          flex-wrap: wrap;
        }

        .intro-mobile-tips {
          display: none;
        }

        .intro-btn-anchor {
          position: relative;
          display: inline-flex;
        }

        .intro-btn-tooltip {
          position: absolute;
          top: calc(100% + 14px);
          left: 0;
          display: flex;
          align-items: flex-start;
          gap: 10px;
          background: #ffffff;
          border: 1px solid #C9EEF8;
          box-shadow: 0px 4px 10px 0px #80DAF180;
          border-radius: 14px;
          padding: 14px 16px;
          width: 260px;
          z-index: 20;
          pointer-events: none;
          animation: fadeInUp 0.18s ease-out;
        }

        .intro-btn-tooltip-arrow {
          position: absolute;
          top: -7px;
          left: 28px;
          width: 14px;
          height: 14px;
          background: #ffffff;
          border-left: 1px solid #C9EEF8;
          border-top: 1px solid #C9EEF8;
          transform: rotate(45deg);
        }

        .intro-btn-tooltip-icon-img {
          width: 34px;
          height: 34px;
          flex-shrink: 0;
        }

        .intro-btn-tooltip-title {
          font-weight: 600;
          font-size: 13px;
          margin-bottom: 4px;
        }

        .intro-btn-tooltip-title.title-primary {
          color: var(--color-brand-primary);
        }

        .intro-btn-tooltip-title.title-button2 {
          color: var(--color-brand-green);
        }

        .intro-btn-tooltip-desc {
          font-size: 12px;
          line-height: 1.5;
          color: #676C80;
        }

        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(-4px); }
          to { opacity: 1; transform: translateY(0); }
        }

        .intro-image-wrapper {
          position: relative;
          width: 100%;
        }

        .intro-image-container {
          width: 100%;
          height: 430px;
          padding-bottom: 70px;
          box-sizing: border-box;
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: flex-start;
        }

        .intro-image {
          width: 100%;
          height: 100%;
          object-fit: contain;
          transform: scale(1.2) translate(30px, 25px);
        }

        .badge-overlay {
          position: absolute;
          top: 10px;
          left: -30px;
          z-index: 2;
        }

        /* TABLET */
        @media (max-width: 1024px) {
          .intro-wrapper {
            padding: 30px;
          }

          .intro-left {
            max-width: 100%;
          }

          .intro-right {
            width: 100%;
          }

          .intro-image-container {
            height: 300px;
            padding-bottom: 20px;
          }

          .intro-image {
            transform: scale(1.1) translate(10px, 20px);
          }

          .badge-overlay {
            left: 0px;
            transform: scale(0.9);
          }
        }

        /* MOBILE */
        /* MOBILE */
@media (max-width: 768px) {
  .intro-wrapper {
    flex-direction: column;
    padding: 24px 20px;
  }

  .intro-left {
    align-items: center;
    text-align: center;
    margin-top: 0;
  }

  .intro-heading {
    font-size: 32px;
    line-height: 38px;
  }

  .intro-subheading {
    font-size: 20px;
    line-height: 28px;
  }

  .intro-desc {
    max-width: 100%;
  }

  .intro-btns {
    justify-content: center;
  }

  /* The badge overhangs its button by design (desktop) — on narrow screens
     that overhang can push past the viewport edge and get clipped, so pull
     it in and shrink it instead. */
  .new-badge {
    top: -8px;
    right: -6px;
    font-size: 9px;
    padding: 2px 7px;
  }

  /* Hover popups can't be reached on touch — the mobile cards below replace them. */
  .intro-btn-tooltip {
    display: none;
  }

  .intro-mobile-tips {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
    margin-top: 16px;
  }

  .intro-mobile-tip {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    text-align: left;
    background: #ffffff;
    border: 1px solid #C9EEF8;
    box-shadow: 0px 4px 10px 0px #80DAF180;
    border-radius: 14px;
    padding: 14px 16px;
  }

  .intro-right {
    width: 100%;
    margin-top: 20px;
  }

  /* A. Increased from 240px → 320px */
  .intro-image-container {
    height:420px;
    padding-bottom: 0;
    justify-content: center;
  }

  /* A. Slightly more scale so image fills the taller container */
  .intro-image {
    transform: scale(1.15) translate(0px, 10px);
  }

  /* B. Reduced badge: smaller scale + repositioned */
  .badge-overlay {
    top: 8px;
    left: 8px;
    transform: scale(0.65);
    transform-origin: top left;
  }
}

        /* SMALL MOBILE */
        /* SMALL MOBILE */
@media (max-width: 480px) {
  .intro-heading {
    font-size: 26px;
    line-height: 32px;
  }

  .intro-subheading {
    font-size: 16px;
  }

  /* A. Increased from 200px → 280px */
  .intro-image-container {
    height: 280px;
    padding-bottom: 0;
  }

  .intro-image {
    transform: scale(1.05) translate(0px, 5px);
  }

  /* B. Even smaller badge on tiny screens */
  .badge-overlay {
    transform: scale(0.55);
    transform-origin: top left;
  }

  .btn-cosmetic {
    font-size: 14px;
    padding: 10px 22px;
  }

  .new-badge {
    top: -6px;
    right: -4px;
    font-size: 8px;
    padding: 2px 6px;
  }
}
      `}</style>

      <div className="intro-wrapper">

        {/* LEFT */}
        <div className="intro-left">
          <h1 className="intro-heading">{heading}</h1>
          <p className="intro-subheading">{subheading}</p>
          <p className="intro-desc">{description}</p>

          <div className="intro-btns">
            {button && (
              <div
                className="intro-btn-anchor"
                onMouseEnter={() => setHoveredBtn('primary')}
                onMouseLeave={() => setHoveredBtn(null)}
              >
                <button className="btn-primary" onClick={onButtonClick}>
                  {button}
                </button>

                {hoveredBtn === 'primary' && (
                  <div className="intro-btn-tooltip">
                    <span className="intro-btn-tooltip-arrow" />
                    <TipContent tip={BUTTON_TIPS.primary} />
                  </div>
                )}
              </div>
            )}

            {button2 && (
              <div
                className="intro-btn-anchor"
                onMouseEnter={() => setHoveredBtn('button2')}
                onMouseLeave={() => setHoveredBtn(null)}
              >
                <button className="btn-cosmetic" onClick={onThirdButtonClick}>
                  {button2}
                </button>
                <span className="new-badge">✨ New</span>

                {hoveredBtn === 'button2' && (
                  <div className="intro-btn-tooltip">
                    <span className="intro-btn-tooltip-arrow" />
                    <TipContent tip={BUTTON_TIPS.button2} />
                  </div>
                )}
              </div>
            )}

            {button1 && (
              <span className="btn-outline-wrapper">
                <button className="btn-outline" onClick={onSecondButtonClick}>
                  {button1}
                </button>
              </span>
            )}
          </div>

          {/* Hover tooltips above are desktop-only (no hover on touch) — mirror
              the same explanations here as always-visible cards for mobile. */}
          <div className="intro-mobile-tips">
            {button && (
              <div className="intro-mobile-tip">
                <TipContent tip={BUTTON_TIPS.primary} />
              </div>
            )}
            {button2 && (
              <div className="intro-mobile-tip">
                <TipContent tip={BUTTON_TIPS.button2} />
              </div>
            )}
          </div>
        </div>

        {/* RIGHT */}
        <div className="intro-right">
          <div className="intro-image-wrapper">

            {image && (
              <div className="intro-image-container">
                <img src={image} alt={heading} className="intro-image" />
              </div>
            )}

            {report_count !== undefined && (
              <div className="reports-badge badge-overlay">
                <div className="badge-count">{report_count}</div>
                <div className="badge-label">Reports Generated</div>
              </div>
            )}

          </div>
        </div>

      </div>
    </div>
  );
};

export default IntroSection;